<template>
  <div class="row">
    <div v-if="!disabled" class="col-md-4 col-sm-12">
      <slot name="selectionInputs" />
      <action-button
        id="chip-selection-add-btn"
        i="fas fa-file-medical"
        text="Añadir"
        variant="success float-right"
        @click="addItem"
      />
    </div>
    <div
      class="col-sm-12 mt-2 mt-md-0"
      :class="{ 'col-md-8 chips-col': !disabled }"
    >
      <label v-if="!disabled" class="field-label font-14">
        {{ selectedItemsTitle }}
      </label>
      <div class="chips-container">
        <div
          v-for="(chipData, index) in selectedItems"
          :key="index"
          class="chip"
        >
          <template v-for="(config, idx) in chipsConfig">
            <span :key="idx">
              <span v-if="config.labelText" class="chip-label">
                {{ config.labelText }}
              </span>
              <span class="chip-field font-weight-bold">
                {{ chipData[config.valueProp] }}
              </span>
            </span>
          </template>
          <a v-if="canDelete(chipData)" @click.prevent="removeChip(index)">
            <em class="far fa-lg fa-times-circle chip-close-icon" />
          </a>
        </div>
        <error
          v-if="errors.length > 0"
          :message="errors[0]"
          variant="no-border"
        />
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
@import '@/shared/scss/config/_colors.scss';
.chip {
  border: 1px solid #b7c4bd;
  border-radius: 16px;
  display: inline-block;
  padding: 2px 4px 2px 14px;
  margin: 0 0.5rem 0.5rem 0.5rem;
}

.chip-label {
  font: 1rem 'Lato';
  letter-spacing: 0;
  color: map-get($colors, 'gray-6');
  font-weight: normal;
}

.chip-field {
  margin-right: 1rem;
  margin-left: 0.25rem;
}

.chip-close-icon {
  color: map-get($colors, 'primary-4');
  vertical-align: -2px;
}

.chips-col {
  border-left: 1px solid map-get($colors, 'gray-5');
}

@media only screen and (max-width: 768px) {
  .chips-col {
    border-left: unset;
  }
}
</style>

<script>
import ActionButton from 'ActionButton';
import Error from 'custom-error';

export default {
  name: 'ChipsSelection',
  meta: {
    description: 'Componente para entrada de selecciones multi-nivel.',
    slots: {
      default: {
        type: 'component',
        valid: [],
      },
    },
  },
  components: {
    ActionButton,
    Error,
  },
  model: {
    prop: 'selectedItems',
    event: 'selectionChanged',
  },
  props: {
    selectedItemsTitle: {
      type: String,
      default: () => null,
    },
    selectedItems: {
      type: Array,
      default: () => [],
    },
    lockedItems: {
      type: Array,
      default: () => [],
    },
    errors: {
      type: Array,
      default: () => [],
    },
    chipsConfig: {
      type: Array,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: () => false,
    },
  },
  computed: {
    hasError() {
      return this.requiredSelectionCount > 0 &&
        this.selectedItems.length < this.requiredSelectionCount
        ? true
        : false;
    },
    canDelete() {
      return (item) => {
        return this.disabled
          ? false
          : !this.lockedItems.includes(item.roleId?.toUpperCase());
      };
    },
  },
  methods: {
    removeChip(index) {
      let deleted = this.selectedItems.splice(index, 1);
      this.$emit('selectionChanged', this.selectedItems);
      this.$emit('removingItem', deleted[0]);
    },
    async addItem() {
      let self = this;
      let preItemCount = this.selectedItems.length;
      let newItem = await this.$listeners.addingItem();

      if (newItem) {
        self.selectedItems.push(newItem);
      }
      if (preItemCount < self.selectedItems.length) {
        self.$emit('selectionChanged', self.selectedItems);
      }
    },
  },
};
</script>
